export const environment = {
  apiBase: 'https://coucou-api.my-accolades.fr',
  jitsiDomain: 'jitsi-cv-xmpp.my-accolades.fr',
  tinyMceApiKey: 'gm9th1ox9827m9vd9hqw6t7byqmn8sx3ur5o0kw74tpfii3o',
  stripe_pk: 'pk_test_51PYmuvFtnjsez2bZ3ct5EcqhSMshoJiq7u8h1o85vfb5abP5tD34JLJvWebvelPzTHEEIp9gsVh0wgVoh7544s4n0074Qh8g1b',
  production: false,
  expirationDaysDelay: 15,
  googleMapsApiKey: 'AIzaSyD3F_YlTXVh_hERnOTrj8GlTr-rux_mJKo',
  clarityProjectId: '',
  googleTagId: '',
  googleAdsId: '',
  googleAdsPurchaseLabel: ''
};
